<template>
    <div>
        <header class="pb-3">
            <b-container>
                <b-row>
                    <b-col>
                        <router-link to="/"><img src="@/assets/thepaymentoption-logo-white.svg" class="logo mt-4"/></router-link>
                    </b-col>
                    <b-col class="text-right pt-5" sm="12" md="9">
                        <ul class="menu">
                            <li class="active"><i class="fas fa-credit-card mr-2"></i>Accounts</li>
                            <router-link tag="li" exact-active-class="active" :to="{name: 'messages', params: {code}}">
                                <i class="fas fa-messages mr-2"></i>Messages
                            </router-link>
<!--                            <li><i class="fas fa-user-cog mr-2"></i>Settings</li>-->
                            <li @click="sessionLogout"><i class="fas fa-sign-out mr-2"></i>Logout</li>
                        </ul>
                    </b-col>
                </b-row>
            </b-container>
        </header>

        <b-container class="mt-5 pb-5 mb-5">
            <b-row>
                <b-col sm="12" md="12" lg="4">
                    <router-link tag="div" v-for="acct in accounts" :to="{name: 'account', params: {id: acct.id}}" exact-active-class="active" class="account">
                        <div>
                            <h6 class="mb-0">{{ acct.nickname }}</h6>
                            <p class="mb-1 meta">24/7 Educational Services</p>
                            <b-row>
                                <b-col class="meta">R{{ acct.id }}</b-col>
                                <b-col class="total text-right">{{ acct.total - acct.paid | currency }}</b-col>
                            </b-row>
                            <div class="mt-3" v-if="acct.active === 0"><b-badge variant="warning" v-b-popover.hover.top="'Automatic payments for this account have been temporarily suspended. Most likely because you contacted us and we are working on your request. Please contact us if you feel this is a mistake.'"><i class="fas fa-pause-circle mr-2"></i>Automatic Payments Suspended<i class="fal fa-question-circle ml-2"></i></b-badge> </div>
                            <div class="mt-3" v-if="(acct.is_error === 1 || !acct.last_four) && acct.total > 0 && (acct.total - acct.paid) > 0"><b-badge variant="danger"><i class="fas fa-exclamation-circle mr-2"></i>Problem with Account</b-badge> </div>
                        </div>
                    </router-link>
                </b-col>
                <b-col>
                    <router-view @resolve="resolve"/>
                </b-col>
            </b-row>
        </b-container>

        <footer class="pt-3 pb-2">
            <b-container>
                <copyright class="mt-3 mb-3"/>
            </b-container>
        </footer>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {mapActions} from "vuex";

    export default {
        name: "accounts",
        components: {Copyright},
        props: ['id', 'code'],
        data: function() {
            return {
                accounts: []
            };
        },
        methods: {
            ...mapActions(['getAccounts', 'logout']),
            sessionLogout: function() {
                this.logout(this.code).then(() => {
                    console.log('Session destroyed.');
                });
                this.$router.push({name: 'home'});
            },
            resolve: function(id) {
                for (let i = 0; i < this.accounts.length; i++) {
                    const account = this.accounts[i];
                    if (account.id === parseInt(id)) account.is_error = 0;
                }
            }
        },
        mounted: function() {
            this.getAccounts(this.code).then(accounts => {
                this.accounts = accounts;
                if (this.accounts.length) {
                    let target = '/accounts/' + this.code + '/' + this.accounts[0].id;
                    if ((this.$route.path !== target)) this.$router.push({name: 'account', params: {id: this.accounts[0].id}});
                }
            }, err => {
                this.$router.push({name: 'home'});
                console.error(err);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .meta {
        font-size: 0.9rem;
        color: grey;
    }

    .total {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .account {
        cursor: pointer;
        margin-bottom: 1rem;

        &:hover {
            background-color: #f4f4f4 !important;
        }

        &.active {
            background-color: #f7f7f7 !important;

            > div {
                border-left: 16px solid $green;
            }
        }

        > div {
            border-left: 16px solid #eeeeee;
            padding: 0.8rem 1.3rem;
            border-radius: 0.25rem;
        }

        border-radius: 0.25rem;
        background-color: #f7f7f7;
    }

    header {
        .logo {
            max-width: 160px;
        }

        background: #3c3c5f;
        color: white;

        .menu {
            list-style: none;

            li {
                display: inline-block;
                margin-left: 1rem;
                padding: 0.2rem 1rem;
                border-radius: 1.5rem;
                cursor: pointer;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.15);
                }

                &.active {
                    background-color: white !important;
                    color: #3c3c5f;
                }

                @media only screen and (max-width: 600px) {
                    padding: 0.5rem;
                    margin-left: 0.5rem;
                }
            }

            @media only screen and (max-width: 600px) {
                text-align: left;
                padding: 0;
            }
        }
    }

    footer {
        border-top: 1px solid $gray-300;
        padding: 2rem 0 0;
        margin-top: 2rem;

        .copyright {
            color: $gray-500 !important;
        }
    }

    .fa-exclamation-triangle {
        color: orangered;
    }
</style>
